module.exports = __webpack_public_path__ + "static/img/spec1.1b8024b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spec1.jpg
// module id = YCxa
// module chunks = 1